namespace RecordShield.Wallet {
    export interface CreditWalletRow {
        Id?: number;
        AccountId?: number;
        JournalId?: string;
        AssetTypeId?: number;
        Credits?: number;
        TransactionId?: number;
        TransactionDate?: string;
        TransactionDetails?: string;
        TransactionNo?: string;
        TenantId?: number;
        AccountUsername?: string;
        AccountDisplayName?: string;
        AccountEmail?: string;
        AccountSource?: string;
        AccountPasswordHash?: string;
        AccountPasswordSalt?: string;
        AccountLastDirectoryUpdate?: string;
        AccountUserImage?: string;
        AccountInsertDate?: string;
        AccountInsertUserId?: number;
        AccountUpdateDate?: string;
        AccountUpdateUserId?: number;
        AccountIsActive?: number;
        AccountIsdCode?: string;
        AccountMobile?: string;
        AccountParentId?: number;
        AccountPackageId?: number;
        AccountCustomerKey?: number;
        AccountTenantId?: number;
        JournalName?: string;
        JournalDescription?: string;
        JournalKind?: number;
        TenantName?: string;
        AssetTypeName?: string;
        AssetTypeDescription?: string;
    }

    export namespace CreditWalletRow {
        export const idProperty = 'Id';
        export const nameProperty = 'JournalId';
        export const localTextPrefix = 'Wallet.CreditWallet';

        export namespace Fields {
            export declare const Id: string;
            export declare const AccountId: string;
            export declare const JournalId: string;
            export declare const AssetTypeId: string;
            export declare const Credits: string;
            export declare const TransactionId: string;
            export declare const TransactionDate: string;
            export declare const TransactionDetails: string;
            export declare const TransactionNo: string;
            export declare const TenantId: string;
            export declare const AccountUsername: string;
            export declare const AccountDisplayName: string;
            export declare const AccountEmail: string;
            export declare const AccountSource: string;
            export declare const AccountPasswordHash: string;
            export declare const AccountPasswordSalt: string;
            export declare const AccountLastDirectoryUpdate: string;
            export declare const AccountUserImage: string;
            export declare const AccountInsertDate: string;
            export declare const AccountInsertUserId: string;
            export declare const AccountUpdateDate: string;
            export declare const AccountUpdateUserId: string;
            export declare const AccountIsActive: string;
            export declare const AccountIsdCode: string;
            export declare const AccountMobile: string;
            export declare const AccountParentId: string;
            export declare const AccountPackageId: string;
            export declare const AccountCustomerKey: string;
            export declare const AccountTenantId: string;
            export declare const JournalName: string;
            export declare const JournalDescription: string;
            export declare const JournalKind: string;
            export declare const TenantName: string;
            export declare const AssetTypeName: string;
            export declare const AssetTypeDescription: string;
        }

        ['Id', 'AccountId', 'JournalId', 'AssetTypeId', 'Credits', 'TransactionId', 'TransactionDate', 'TransactionDetails', 'TransactionNo', 'TenantId', 'AccountUsername', 'AccountDisplayName', 'AccountEmail', 'AccountSource', 'AccountPasswordHash', 'AccountPasswordSalt', 'AccountLastDirectoryUpdate', 'AccountUserImage', 'AccountInsertDate', 'AccountInsertUserId', 'AccountUpdateDate', 'AccountUpdateUserId', 'AccountIsActive', 'AccountIsdCode', 'AccountMobile', 'AccountParentId', 'AccountPackageId', 'AccountCustomerKey', 'AccountTenantId', 'JournalName', 'JournalDescription', 'JournalKind', 'TenantName', 'AssetTypeName', 'AssetTypeDescription'].forEach(x => (<any>Fields)[x] = x);
    }
}
